import { NOTIFICATION_CATEGORIES, NOTIFICATION_IMPORTANCE_LEVELS, NOTIFICATION_TYPES } from '@/config/constants/notificationConstants';
import { computed } from 'vue'
import { useI18n } from "vue-i18n";

export default function useNotificationCategoriesAndTypes() {
	const { t: $t } = useI18n()

	const notificationCategories = computed(() => {
		return {
			[NOTIFICATION_CATEGORIES.ACCOUNTING]: {
				title: $t('Accounting'),
				value: NOTIFICATION_CATEGORIES.ACCOUNTING,
			},
			[NOTIFICATION_CATEGORIES.DEVICES_AND_SENSORS]: {
				title: $t('Devices and sensors'),
				value: NOTIFICATION_CATEGORIES.DEVICES_AND_SENSORS,
			},
			[NOTIFICATION_CATEGORIES.WORKS]: {
				title: $t('Works'),
				value: NOTIFICATION_CATEGORIES.WORKS,
			},
			[NOTIFICATION_CATEGORIES.INFRASTRUCTURE_EVENTS]: {
				title: $t('Infrastructure events'),
				value: NOTIFICATION_CATEGORIES.INFRASTRUCTURE_EVENTS,
			},
			[NOTIFICATION_CATEGORIES.SYSTEM]: {
				title: $t('System'),
				value: NOTIFICATION_CATEGORIES.SYSTEM,
			},
			[NOTIFICATION_CATEGORIES.INCIDENTS]: {
				title: $t('Incidents'),
				value: NOTIFICATION_CATEGORIES.INCIDENTS,
			},
			[NOTIFICATION_CATEGORIES.OTHER]: {
				title: $t('Other'),
				value: NOTIFICATION_CATEGORIES.OTHER,
			},
		}
	})

	const notificationTypes = computed(() => {
		return {
			[NOTIFICATION_TYPES.TELEMATICS_NO_GPS_DATA_WHEN_WORK_EXPECTED]: {
				value: NOTIFICATION_TYPES.TELEMATICS_NO_GPS_DATA_WHEN_WORK_EXPECTED,
				title: $t('No GPS data when work is expected'),
				importanceLevel: NOTIFICATION_IMPORTANCE_LEVELS.ALERT,
				category: NOTIFICATION_CATEGORIES.DEVICES_AND_SENSORS,
				iconKey: 'notifyTelematicsNoGpsDataWhenWorkExpected',
			},

			[NOTIFICATION_TYPES.WORK_ORDER_QUALITY_ISSUE]: {
				value: NOTIFICATION_TYPES.WORK_ORDER_QUALITY_ISSUE,
				title: $t('Violation of quality of work'),
				importanceLevel: NOTIFICATION_IMPORTANCE_LEVELS.ALERT,
				category: NOTIFICATION_CATEGORIES.WORKS,
				iconKey: 'notifyWorkOrderQualityIssue',
			},

			[NOTIFICATION_TYPES.MOVING_ON_FIELD_WITHOUT_WORK_ORDER]: {
				value: NOTIFICATION_TYPES.MOVING_ON_FIELD_WITHOUT_WORK_ORDER,
				title: $t('Moving around the field without an order'),
				importanceLevel: NOTIFICATION_IMPORTANCE_LEVELS.ALERT,
				category: NOTIFICATION_CATEGORIES.WORKS,
				iconKey: 'notifyMovingOnFieldWithoutWorkOrder',
			},

			[NOTIFICATION_TYPES.USING_SCREW_WITHOUT_MACHINE_NEARBY_15M]: {
				value: NOTIFICATION_TYPES.USING_SCREW_WITHOUT_MACHINE_NEARBY_15M,
				title: $t('Turning on the auger when there is no other truck or reloader within a radius of 15 meters'),
				importanceLevel: NOTIFICATION_IMPORTANCE_LEVELS.ALERT,
				category: NOTIFICATION_CATEGORIES.DEVICES_AND_SENSORS,
				iconKey: 'notifyUsingScrewWithoutMachineNearby15m',
			},

			[NOTIFICATION_TYPES.DECREASING_BUNKER_SENSOR_LEVEL_WITHOUT_USING_SCREW]: {
				value: NOTIFICATION_TYPES.DECREASING_BUNKER_SENSOR_LEVEL_WITHOUT_USING_SCREW,
				title: $t('Decrease in bulk solids sensor level without turning on the auger'),
				importanceLevel: NOTIFICATION_IMPORTANCE_LEVELS.ALERT,
				category: NOTIFICATION_CATEGORIES.DEVICES_AND_SENSORS,
				iconKey: 'notifyDecreasingBunkerSensorLevelWithoutUsingScrew',
			},

			[NOTIFICATION_TYPES.USING_SCREW_WITHOUT_IDENTIFICATION]: {
				value: NOTIFICATION_TYPES.USING_SCREW_WITHOUT_IDENTIFICATION,
				title: $t('Turning on the auger sensor without driver identification'),
				importanceLevel: NOTIFICATION_IMPORTANCE_LEVELS.ALERT,
				category: NOTIFICATION_CATEGORIES.DEVICES_AND_SENSORS,
				iconKey: 'notifyUsingScrewWithoutIdentification',
			},

			[NOTIFICATION_TYPES.FUEL_DRAIN]: {
				value: NOTIFICATION_TYPES.FUEL_DRAIN,
				title: $t('Fuel drain'),
				importanceLevel: NOTIFICATION_IMPORTANCE_LEVELS.ALERT,
				category: NOTIFICATION_CATEGORIES.DEVICES_AND_SENSORS,
				iconKey: 'notifyFuelDrain',
			},

			[NOTIFICATION_TYPES.LONG_STOP_WHEN_WORK_EXPECTED]: {
				value: NOTIFICATION_TYPES.LONG_STOP_WHEN_WORK_EXPECTED,
				title: $t('Long stop when work is expected'),
				importanceLevel: NOTIFICATION_IMPORTANCE_LEVELS.ALERT,
				category: NOTIFICATION_CATEGORIES.WORKS,
				iconKey: 'notifyLongStopWhenWorkExpected',
			},

			[NOTIFICATION_TYPES.FIELD_WORKS_SUMMARY_REPORT]: {
				value: NOTIFICATION_TYPES.FIELD_WORKS_SUMMARY_REPORT,
				title: $t('Field works summary report'),
				importanceLevel: NOTIFICATION_IMPORTANCE_LEVELS.INFO,
				category: NOTIFICATION_CATEGORIES.WORKS,
				iconKey: 'dailyPlanDone',
			},

			// // works
			// work_started: {
			// 	title: $t('Beginning of work'),
			// 	value: 'work_started',
			// 	importance_level: 'info',
			// 	iconKey: 'startWork',
			// 	category: 'works',
			// },
			// work_completed: {
			// 	title: $t('End of work'),
			// 	value: 'work_completed',
			// 	importance_level: 'info',
			// 	iconKey: 'completeWork',
			// 	category: 'works',
			// },
			// work_has_some_rule_breaking: {
			// 	title: $t('Violation of the work regulations'),
			// 	value: 'work_has_some_rule_breaking',
			// 	importance_level: 'alert',
			// 	iconKey: 'workHasSomeRuleBreaking',
			// 	category: 'works',
			// },
			// work_closed: {
			// 	title: $t('Work closed'),
			// 	value: 'work_closed',
			// 	iconKey: 'workClosed',
			// 	importance_level: 'info',
			// 	category: 'works',
			// },
			// work_order_not_started: {
			// 	title: $t('Did not start work on orders'),
			// 	value: 'work_order_not_started',
			// 	importance_level: 'alert',
			// 	iconKey: 'idleTechnicOverTime',
			// 	category: 'works',
			// },
			// works_daily_plan_report: {
			// 	title: $t('Execution of the daily plan'),
			// 	value: 'works_daily_plan_report',
			// 	importance_level: 'info',
			// 	iconKey: 'dailyPlanDone',
			// 	category: 'works',
			// },
			// device_in_motion_without_order: {
			// 	title: $t('Machine in motion without order'),
			// 	value: 'device_in_motion_without_order',
			// 	importance_level: 'warning',
			// 	iconKey: 'technicWithoutOutfit',
			// 	category: 'works',
			// },
			// some_orders_not_closed: {
			// 	title: $t('Remaining unfinished orders'),
			// 	value: 'some_orders_not_closed',
			// 	importance_level: 'warning',
			// 	iconKey: 'uncoveredOutfits',
			// 	category: 'works',
			// },
			// // devices and device events
			// device_no_data_today: {
			// 	title: $t('Missing data on machine running today'),
			// 	value: 'device_no_data_today',
			// 	importance_level: 'warning',
			// 	iconKey: 'technicNoDataToday',
			// 	category: 'devices_and_sensors',
			// },
			// decreasing_sensor_level_without_using_screw: {
			// 	title: $t('Reduction of bulk sensor level without screw on'),
			// 	value: 'decreasing_sensor_level_without_using_screw',
			// 	importance_level: 'alert',
			// 	iconKey: 'downBulkSensorWithoutAuger',
			// 	category: 'devices_and_sensors',
			// },
			// // incidents
			// you_was_assigned_to_new_incident: {
			// 	title: $t('Assigned to a new incident'),
			// 	value: 'you_was_assigned_to_new_incident',
			// 	importance_level: 'info',
			// 	iconKey: `newIncident`,
			// 	category: 'incidents',
			// },
			// new_incident_comment: {
			// 	title: $t('New comment on the incident'),
			// 	value: 'new_incident_comment',
			// 	importance_level: 'info',
			// 	iconKey: `newIncidentComment`,
			// 	category: 'incidents',
			// },
			// // system
			// new_employee: {
			// 	title: $t('New employee registered'),
			// 	value: 'new_employee',
			// 	importance_level: 'info',
			// 	iconKey: 'newEmployee',
			// 	category: 'system',
			// },
			// license_less_30_days_left: {
			// 	title: $t('[days] days of license remaining', { days: 30 }),
			// 	value: 'license_less_30_days_left',
			// 	importance_level: 'warning',
			// 	iconKey: 'licenseLess30',
			// 	category: 'system',
			// },
			// license_less_10_days_left: {
			// 	title: $t('[days] days of license remaining', { days: 10 }),
			// 	value: 'license_less_10_days_left',
			// 	importance_level: 'warning',
			// 	iconKey: 'licenseLess10',
			// 	category: 'system',
			// },
			// license_one_day_days_left: {
			// 	title: $t('License expires tomorrow'),
			// 	value: 'license_one_day_days_left',
			// 	importance_level: 'warning',
			// 	iconKey: 'licenseOneDay',
			// 	category: 'system',
			// },
			// new_user_registered: {
			// 	title: $t('New user registered'),
			// 	value: 'new_user_registered',
			// 	importance_level: 'info',
			// 	iconKey: 'newUserRegistered',
			// 	category: 'system',
			// },
			// new_company_registered: {
			// 	title: $t('New company registered'),
			// 	value: 'new_company_registered',
			// 	importance_level: 'info',
			// 	iconKey: 'newCompanyRegistered',
			// 	category: 'system',
			// },
			// // integration
			// new_fuel_station_event: {
			// 	title: $t('New fuel station event'),
			// 	value: 'new_fuel_station_event',
			// 	importance_level: 'info',
			// 	iconKey: 'newFuelStationEvent',
			// 	category: 'infrastructure_events',
			// },
			// new_weighing_station_event: {
			// 	title: $t('New weight platform event'),
			// 	value: 'new_weighing_station_event',
			// 	importance_level: 'info',
			// 	iconKey: 'newWeighingStationEvent',
			// 	category: 'infrastructure_events',
			// },
			// test: {
			// 	title: $t('Test'),
			// 	value: 'test',
			// 	importance_level: 'info',
			// 	iconKey: `newIncidentComment`,
			// 	category: 'incidents',
			// },
			// license_one_day_left: {
			// 	title: $t('The license expires tomorrow'),
			// 	value: 'license_one_day_left',
			// 	importance_level: 'alert',
			// 	iconKey: `licenseTomorrow`,
			// 	category: 'system',
			// },
		}
	})


	return {
		notificationCategories,
		notificationCategoriesArray: Object.values(notificationCategories.value),
		notificationTypes,
		notificationTypesArray: Object.values(notificationTypes.value),
	}
}
